import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Login from "@/pages/Login";
import Account from "@/pages/Account";
import TrackOrder from "@/pages/TrackOrder";
import Policy from "@/pages/Policy";
import HostingerGuide from "@/pages/HostingerGuide";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={withLayout(<Home />)} />
            <Route path="/shop" element={withLayout(<Shop />)} />
            <Route path="/product/:id" element={withLayout(<ProductDetail />)} />
            <Route path="/checkout" element={withLayout(<Checkout />)} />
            <Route path="/order-success/:orderNumber" element={withLayout(<OrderSuccess />)} />
            <Route path="/login" element={withLayout(<Login />)} />
            <Route path="/account" element={withLayout(<Account />)} />
            <Route path="/track" element={withLayout(<TrackOrder />)} />
            <Route path="/track/:orderNumber" element={withLayout(<TrackOrder />)} />
            <Route path="/policy/:slug" element={withLayout(<Policy />)} />
            <Route path="/hostinger-setup" element={withLayout(<HostingerGuide />)} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
